export const loaderActionTypes = {
  SetLoader: "loader/SetLoader",
  SetKey: "loader/Setkey",
};

export const loaderActions = {
  SetLoader: (payload) => ({ type: loaderActionTypes.SetLoader, payload }),
  SetKey: (payload) => ({ type: loaderActionTypes.SetKey, payload }),
};
